import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  signal,
  viewChild
} from '@angular/core';
import { GroupedHeaderColumnsComponent } from '../grouped-header-columns/grouped-header-columns.component';
import {
  UpdateInputNumberComponent
} from '../../../../../shared/components/update-input/update-input-number.component';

@Component({
  selector: 'app-grouped-value-columns',
  standalone: true,
  imports: [
    UpdateInputNumberComponent
  ],
  templateUrl: './grouped-value-columns.component.html',
  styleUrls: [
    '../grouped-header-columns/grouped-header-columns.component.scss',
    './grouped-value-columns.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupedValueColumnsComponent extends GroupedHeaderColumnsComponent implements OnInit {
  isIntegrationsPlan = input<boolean>(false);
  isAssignedManager = input<boolean>(false);
  updateIntegrationsPlan = output<number>();
  updateInputNumberComponent = viewChild<UpdateInputNumberComponent | null>('updateInputNumberComponent');

  public isEditState = signal<boolean>(false);
  public userCanEdit = signal<boolean>(false);

  public ngOnInit(): void {
    this.userCanEdit.set(this.isUserCanEdit());
  }

  public isIntegrationsColumn(index: number): boolean {
    return this.isIntegrationsPlan() && index === this.columns().length - 1;
  }

  public openEditState(): void {
    this.isEditState.set(true);
  }

  public closeEditState(): void {
    this.isEditState.set(false);
  }

  public handleEditStateChange(isEditState: boolean): void {
    this.userCanEdit.set(this.isUserCanEdit());
    isEditState ? this.openEditState() : this.closeEditState();
  }

  public handleValueClick(): void {
    this.updateInputNumberComponent()?.openEditState();
  }

  public handleSaveIntegrations(value: number): void {
    this.updateIntegrationsPlan.emit(value);
  }

  public isUserCanEdit(): boolean {
    return this.updateInputNumberComponent()?.isUserCanEdit() ?? false;
  }
}
